<template>
  <Dropdown :class="[inline ? 'inline-block' : 'panel-dropdown']">
    <div
      class="relative rounded-tr text-sm"
      slot-scope="{didClickInside, didClickOutside, isOpen}"
      @click="didClickInside"
      v-click-outside="didClickOutside"
    >
      <div class="cursor-pointer focus:outline-none" :class="{'underline text-cardstock-blue-600': inline}">
        <slot name="panel-dropdown__button"></slot>
      </div>

      <Transition
      enter-active-class="transition ease-out duration-100 transform"
      enter-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75 transform"
      leave-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95">
        <div
          class="panel-dropdown__menu"
          :class="{'panel-dropdown__menu--small': (size == 'small'), 'panel-dropdown__menu--left': (side == 'left')}"
          v-show="isOpen"
        >
          <div
            class="panel-dropdown__menu-pointer"
            :class="{'panel-dropdown__menu-pointer--left': (side == 'left')}"
          >
            <div
              class="panel-dropdown__menu-pointer-body panel-dropdown__menu-pointer-body--edge"
              :class="{'panel-dropdown__menu-pointer-body--left': (side == 'left')}"
            ></div>
            <div
              class="panel-dropdown__menu-pointer-body"
              :class="{'panel-dropdown__menu-pointer-body--left': (side == 'left')}"
            ></div>
          </div>
          <div
            class="panel-dropdown__menu-items"
            :class="{'panel-dropdown__menu-items--left': (side == 'left')}"
          >
            <div v-for="(item, index) in items">
              <router-link
                class="panel-dropdown__menu-item"
                :key="index"
                :to="item.to"
                v-if="item.to"
              >
                {{item.text}}
              </router-link>
              <button
                class="panel-dropdown__menu-item"
                @click="item.click"
                v-else-if="item.click"
              >
                {{item.text}}
              </button>
              <button
                class="panel-dropdown__menu-item"
                v-else
              >
                {{item.text}}
              </button>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </Dropdown>
</template>

<script>
import Dropdown from '@/components/Dropdown.vue'
export default {
  components: {
    Dropdown
  },

  props: ['inline', 'items', 'size', 'side']
}
</script>
